import { createContext, useContext, useEffect, useState } from "react";

export const WHATSAPP_URL = "https://wa.me/5561985275734";
export const EMAIL = "contato@orqestria.com.br";
export const EMAIL_URL = `mailto:${EMAIL}`;

export const HERO_BG =
  "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&q=85";
export const IMG_CIRCUIT =
  "https://images.unsplash.com/photo-1727434032773-af3cd98375ba?crop=entropy&cs=srgb&fm=jpg&q=85";
export const IMG_SCREEN =
  "https://images.pexels.com/photos/33433724/pexels-photo-33433724.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const dict = {
  pt: {
    nav: {
      ciclo: "O ciclo",
      atuar: "Atuação",
      governanca: "Governança",
      pilares: "Pilares",
      paraQuem: "Para quem",
      contato: "Contato",
      cta: "Falar com a Orqestria",
      menu: "Abrir menu",
    },
    hero: {
      tag: "Serviços de tecnologia AI-native",
      lines: [
        [{ t: "Software construído" }],
        [{ t: "por " }, { t: "agentes", hl: 1 }, { t: "," }],
        [{ t: "governado por design." }],
      ],
      sub: "Engenharia de Software Agent-Native: Do conceito ao rollout, arquitetamos o ciclo completo de inovação com agentes autônomos no núcleo, governança integrada e loops contínuos de melhoria.",
      ctaWpp: "Falar no WhatsApp",
      ctaEmail: "contato@orqestria.com.br",
      emailCopied: "e-mail copiado ✓",
      ctaScroll: "Explorar o ciclo",
      chips: ["AI_NATIVE", "GOVERNANCE_BY_DESIGN", "PRIVACY_BY_DESIGN", "SECURE_CODE"],
      termTitle: "orqestria — ciclo agêntico",
      term: [
        "$ orqestria run ciclo --end-to-end",
        "▸ ideacao      3 teses validadas",
        "▸ governanca   políticas aplicadas ✓",
        "▸ sdlc         12 PRs gerados e revisados",
        "▸ homologacao  gates aprovados",
        "▸ rollout      canário 5% → 100%",
        "▸ observacao   degradação detectada → realimenta o ciclo ↻",
      ],
    },
    marquee: [
      "Governance by design",
      "AI Native",
      "AI First",
      "Privacy by design",
      "Secure Code",
      "Observability always-on",
    ],
    start: {
      label: "O ponto de partida",
      heading: "Processos desenhados para humanos não sobrevivem ao ciclo agêntico.",
      sub: "Engenharia, projetos, disciplinas e metas que faziam sentido ontem deixam de fazer sentido quando agentes entram no time.",
      legacyTitle: "Adaptar o que existe",
      legacy: [
        "IA enxertada em processos legados",
        "Governança como relatório trimestral",
        "Time inteiro para manter o jeito antigo de trabalhar",
        "Telemetria que ninguém olha",
      ],
      nativeTitle: "Nascer nativo",
      native: [
        "Agentes no centro do ciclo de vida",
        "Governança aplicada em runtime",
        "Humanos em delegação, crítica e decisão",
        "Observabilidade que realimenta o ciclo",
      ],
    },
    ciclo: {
      label: "Serviços",
      heading: "O ciclo agêntico, ponta a ponta.",
      sub: "Um fluxo contínuo da ideia ao observável — não uma consultoria por etapa.",
      cards: [
        { id: "01", key: "ideacao", icon: "lightbulb", title: "Ideação & Descoberta", desc: "Novos negócios nascem aqui. Agentes mapeiam oportunidades, prototipam teses e validam viabilidade técnica e de mercado em dias — não trimestres." },
        { id: "02", key: "governanca", icon: "scale", title: "Governança & Projetos", desc: "Guardrails com limites claros e controles automatizados no pipeline: políticas, papéis e metas redesenhados para o ciclo agêntico, aplicados em runtime — não em PDF." },
        { id: "03", key: "sdlc", icon: "workflow", title: "SDLC Agêntico", desc: "Engenharia com agentes gerando, revisando e testando código sob supervisão humana. Secure code e privacy by design em cada commit.", steps: ["Intenção técnica revisada", "Requisitos e design técnico", "Tarefas na medida para agentes", "Testes amplos e eficientes", "Guardrails no harness e na plataforma DevSecOps"] },
        { id: "04", key: "entregas", icon: "check", title: "Entregas & Homologação", desc: "Fluxos de homologação contínuos, com gates automatizados e trilha de auditoria completa." },
        { id: "05", key: "rollout", icon: "rocket", title: "Rollout & Release", desc: "Deploy canário, feature flags e reversão automática. Release deixa de ser evento e vira rotação." },
        { id: "06", key: "obs", icon: "radar", title: "Observabilidade Retroalimentando", desc: "Degradação, anomalias e observações de produção voltam ao ciclo como insumo. O sistema aprende com o próprio tráfego." },
        { id: "07", key: "diagnostico", icon: "arrow", title: "Diagnóstico do seu ciclo", desc: "Raio-x de 30 min do seu fluxo atual, sem custo, com um mapa de agente por etapa. Resposta em 1 dia útil.", diagCta: "Agendar diagnóstico ↗" },
      ],
    },
    pilares: {
      label: "Pilares",
      heading: "Não é selo na parede. É padrão de fábrica.",
      sub: "Cada entrega nasce sob os mesmos princípios — sem exceção, sem atalho.",
      items: [
        { id: "PLT-01", icon: "shield", title: "Governance by design", desc: "Velocidade e controle não são objetivos conflitantes: toda entrega nasce sob política, trilha de auditoria e controle de acesso. Governança não é fase: é fundação." },
        { id: "PLT-02", icon: "cpu", title: "AI Native", desc: "Processos desenhados para agentes desde o primeiro diagrama — não IA colada em fluxo legado." },
        { id: "PLT-03", icon: "brain", title: "AI First", desc: "Toda decisão de arquitetura começa pela pergunta: e se um agente fizesse isso?" },
        { id: "PLT-04", icon: "lock", title: "Privacy by design", desc: "Dados minimizados, isolamento e criptografia por padrão, alinhados à LGPD e a padrões globais." },
        { id: "PLT-05", icon: "code", title: "Secure Code", desc: "Threat modeling, análise estática e revisão agêntica em cada commit. Segurança é código, não checklist." },
        { id: "PLT-06", icon: "radar", title: "Observability by design", desc: "Telemetria como requisito funcional. Sem observabilidade não existe ciclo — existe tentativa e erro." },
      ],
    },
    consult: {
      label: "Atuação",
      heading: "Consultoria de TI para o desenvolvimento de software com IA.",
      sub: "Aplicamos frameworks próprios — usando a stack da contratante ou a nossa — para amadurecer o ciclo de vida do desenvolvimento agêntico, com impacto em negócio e TI.",
      cards: [
        { icon: "layers", title: "Frameworks próprios", desc: "Métodos agênticos desenhados e evoluídos pela Orqestria e aplicados ao seu contexto — não um manual genérico de mercado." },
        { icon: "blocks", title: "A sua stack ou a nossa", desc: "Trabalhamos com a stack da contratante ou operamos com a nossa. A ferramenta importa menos que o ciclo certo." },
        { icon: "trend", title: "Maturidade em ciclos", desc: "Diagnóstico, redesign e playbook do ciclo de vida agêntico, com governança e métricas de valor desde o dia 1." },
        { icon: "target", title: "Impacto em negócio e TI", desc: "Sucesso medido em resultados: lead time, adoção, experiência e captura de valor — não só projetos entregues." },
      ],
    },
    gov: {
      label: "Governança por design",
      heading: "Governança que nasce com a solução — não que trava no fim.",
      sub: "Velocidade e controle não são objetivos conflitantes. Incorporamos segurança, arquitetura, compliance e resiliência desde a concepção, sem transformar requisitos em obstáculo à inovação.",
      cards: [
        { icon: "shield", title: "Nasce governável", desc: "Requisitos de segurança, arquitetura, qualidade, compliance e resiliência nos pipelines desde a concepção. A solução nasce conforme — não é aprovada depois." },
        { icon: "route", title: "Guardrails, não cancelas", desc: "Limites claros e predefinidos dão autonomia para inovar; controles não negociáveis entram automatizados no fluxo de trabalho." },
        { icon: "history", title: "Sem governance debt", desc: "Quando a governança só atua no fim do ciclo, exceções acumulam retrabalho, custo e vulnerabilidade. Presente no ciclo inteiro, ela antecipa problemas." },
        { icon: "user", title: "Autonomia com supervisão", desc: "Níveis de autonomia proporcionais ao risco, com rastreabilidade, explicabilidade e escalonamento para supervisão humana — o desafio agêntico." },
      ],
      quote: "O sucesso de TI não é mais apenas entregar projetos, é gerar resultados.",
      quoteBy: "Cristina Pinna, diretora de TI do Bradesco, em entrevista à TI Inside (2026)",
    },
    audi: {
      label: "Para quem",
      heading: "Dois pontos de partida, um mesmo destino.",
      a: {
        tag: "Trilha 01 — Times de TI",
        title: "Empresas de TI e times de desenvolvimento",
        desc: "Amadureça o processo interno dos seus times: engenharia, projetos, disciplinas e metas redesenhadas para o ciclo agêntico — sem desperdiçar o que já funciona.",
        bullets: [
          "Diagnóstico do fluxo de desenvolvimento atual",
          "Redesenho do SDLC com agentes no ciclo",
          "Playbooks de governança, métricas e metas",
        ],
      },
      b: {
        tag: "Trilha 02 — Negócios nativos",
        title: "Negócios que querem nascer nativos",
        desc: "Crie soluções AI-nativas para o seu negócio, da ideação à operação, com IA impactando os fluxos de ponta a ponta.",
        bullets: [
          "Ideação e validação de teses com agentes",
          "Construção do produto com ciclo agêntico",
          "Rollout com observabilidade e retroalimentação",
        ],
      },
    },
    quote: {
      by: "Manifesto Orqestria",
      text: "A pergunta certa deixou de ser “onde encaixo IA?”. Hoje é “o que esse processo vira quando agentes fazem parte dele?”",
    },
    cta: {
      label: "Contato",
      heading: "Pronto para o ciclo agêntico?",
      sub: "Direto ao ponto, sem formulário. Escolha o canal.",
      wpp: "Falar no WhatsApp",
      email: "Enviar e-mail",
      note: "WhatsApp · E-mail — sem formulários · resposta em 1 dia útil",
    },
    footer: {
      tag: "Uma inteligência. Muitos agentes.",
      made: "Feito por agentes, supervisionado por humanos.",
    },
  },
  en: {
    nav: {
      ciclo: "The cycle",
      atuar: "How we work",
      governanca: "Governance",
      pilares: "Pillars",
      paraQuem: "Who it's for",
      contato: "Contact",
      cta: "Talk to Orqestria",
      menu: "Open menu",
    },
    hero: {
      tag: "AI-native technology services",
      lines: [
        [{ t: "Software built" }],
        [{ t: "by " }, { t: "agents", hl: 1 }, { t: "," }],
        [{ t: "governed by design." }],
      ],
      sub: "IT consulting for AI-driven software development: we design the full cycle — from new business ideation to rollout — with agents at the center, governance by design and observability feeding every delivery.",
      ctaWpp: "Chat on WhatsApp",
      ctaEmail: "contato@orqestria.com.br",
      emailCopied: "email copied ✓",
      ctaScroll: "Explore the cycle",
      chips: ["AI_NATIVE", "GOVERNANCE_BY_DESIGN", "PRIVACY_BY_DESIGN", "SECURE_CODE"],
      termTitle: "orqestria — agentic cycle",
      term: [
        "$ orqestria run cycle --end-to-end",
        "▸ ideation      3 theses validated",
        "▸ governance    policies enforced ✓",
        "▸ sdlc          12 PRs generated & reviewed",
        "▸ staging       gates approved",
        "▸ rollout       canary 5% → 100%",
        "▸ observe       degradation caught → feeds the cycle back ↻",
      ],
    },
    marquee: [
      "Governance by design",
      "AI Native",
      "AI First",
      "Privacy by design",
      "Secure Code",
      "Observability always-on",
    ],
    start: {
      label: "The starting point",
      heading: "Processes designed for humans don't survive the agentic cycle.",
      sub: "Engineering, projects, disciplines and goals that made sense yesterday stop making sense when agents join the team.",
      legacyTitle: "Adapt what exists",
      legacy: [
        "AI grafted onto legacy processes",
        "Governance as a quarterly report",
        "Whole teams maintaining the old way of working",
        "Telemetry nobody looks at",
      ],
      nativeTitle: "Born native",
      native: [
        "Agents at the center of the lifecycle",
        "Governance enforced at runtime",
        "Humans on delegation, critique and decisions",
        "Observability that feeds the cycle back",
      ],
    },
    ciclo: {
      label: "Services",
      heading: "The agentic cycle, end to end.",
      sub: "One continuous flow from idea to observable — not a consultancy per stage.",
      cards: [
        { id: "01", key: "ideacao", icon: "lightbulb", title: "Ideation & Discovery", desc: "New businesses are born here. Agents map opportunities, prototype theses and validate technical and market viability in days — not quarters." },
        { id: "02", key: "governanca", icon: "scale", title: "Governance & Projects", desc: "Guardrails with clear limits and controls automated into the pipeline: policies, roles and goals redesigned for the agentic cycle, enforced at runtime — not in a PDF." },
        { id: "03", key: "sdlc", icon: "workflow", title: "Agentic SDLC", desc: "Engineering with agents generating, reviewing and testing code under human supervision. Secure code and privacy by design on every commit.", steps: ["Reviewed technical intent", "Requirements & technical design", "Right-sized tasks for agents", "Broad, efficient testing", "Guardrails in the harness and DevSecOps platform"] },
        { id: "04", key: "entregas", icon: "check", title: "Delivery & Staging", desc: "Continuous staging flows with automated gates and a complete audit trail." },
        { id: "05", key: "rollout", icon: "rocket", title: "Rollout & Release", desc: "Canary deploys, feature flags and automatic rollback. Release stops being an event and becomes rotation." },
        { id: "06", key: "obs", icon: "radar", title: "Observability Feeding Back", desc: "Degradation, anomalies and production observations return to the cycle as input. The system learns from its own traffic." },
        { id: "07", key: "diagnostico", icon: "arrow", title: "Cycle diagnostics", desc: "A 30-min x-ray of your current flow, free of charge, with an agent map per stage. Reply within 1 business day.", diagCta: "Book your diagnosis ↗" },
      ],
    },
    pilares: {
      label: "Pillars",
      heading: "Not a badge on the wall. The factory default.",
      sub: "Every delivery is born under the same principles — no exceptions, no shortcuts.",
      items: [
        { id: "PLT-01", icon: "shield", title: "Governance by design", desc: "Speed and control are not conflicting goals: every delivery is born under policy, audit trail and access control. Governance isn't a phase: it's the foundation." },
        { id: "PLT-02", icon: "cpu", title: "AI Native", desc: "Processes designed for agents from the first diagram — not AI glued onto legacy flows." },
        { id: "PLT-03", icon: "brain", title: "AI First", desc: "Every architecture decision starts with the question: what if an agent did this?" },
        { id: "PLT-04", icon: "lock", title: "Privacy by design", desc: "Data minimization, isolation and encryption by default, aligned with GDPR and global standards." },
        { id: "PLT-05", icon: "code", title: "Secure Code", desc: "Threat modeling, static analysis and agentic review on every commit. Security is code, not a checklist." },
        { id: "PLT-06", icon: "radar", title: "Observability by design", desc: "Telemetry as a functional requirement. Without observability there is no cycle — only trial and error." },
      ],
    },
    consult: {
      label: "How we work",
      heading: "IT consulting for AI-driven software development.",
      sub: "We apply our own frameworks — using the contractor's stack or ours — to mature the agentic development lifecycle, with impact on business and IT.",
      cards: [
        { icon: "layers", title: "Proprietary frameworks", desc: "Agentic methods designed and evolved by Orqestria and applied to your context — not a generic market playbook." },
        { icon: "blocks", title: "Your stack or ours", desc: "We work with the contractor's stack or operate with ours. The tool matters less than the right cycle." },
        { icon: "trend", title: "Maturity in cycles", desc: "Diagnosis, redesign and playbook of the agentic lifecycle, with governance and value metrics from day 1." },
        { icon: "target", title: "Business and IT impact", desc: "Success measured in results: lead time, adoption, experience and value capture — not just delivered projects." },
      ],
    },
    gov: {
      label: "Governance by design",
      heading: "Governance born with the solution — not blocking it at the end.",
      sub: "Speed and control are not conflicting objectives. We embed security, architecture, compliance and resilience from conception, without turning requirements into innovation roadblocks.",
      cards: [
        { icon: "shield", title: "Born governable", desc: "Security, architecture, quality, compliance and resilience requirements built into pipelines from conception. The solution is born compliant — not approved afterwards." },
        { icon: "route", title: "Guardrails, not roadblocks", desc: "Clear, predefined limits give teams autonomy to innovate; non-negotiable controls are automated into the workflow." },
        { icon: "history", title: "No governance debt", desc: "When governance only acts at the end of the cycle, exceptions accumulate into rework, cost and vulnerability. Present across the whole cycle, it anticipates problems." },
        { icon: "user", title: "Autonomy with oversight", desc: "Autonomy levels proportional to risk, with traceability, explainability and escalation to human oversight — the agentic challenge." },
      ],
      quote: "IT success is no longer just about delivering projects; it's about generating results.",
      quoteBy: "Cristina Pinna, IT Director at Bradesco, in an interview with TI Inside (2026)",
    },
    audi: {
      label: "Who it's for",
      heading: "Two starting points, one destination.",
      a: {
        tag: "Track 01 — IT teams",
        title: "IT companies and dev teams",
        desc: "Mature your teams' internal process: engineering, projects, disciplines and goals redesigned for the agentic cycle — without wasting what already works.",
        bullets: [
          "Diagnosis of your current development flow",
          "SDLC redesign with agents in the cycle",
          "Governance, metrics and goals playbooks",
        ],
      },
      b: {
        tag: "Track 02 — Native businesses",
        title: "Businesses that want to be born native",
        desc: "Build AI-native solutions for your business, from ideation to operations, with AI impacting end-to-end flows.",
        bullets: [
          "Ideation and thesis validation with agents",
          "Product building with the agentic cycle",
          "Rollout with observability and feedback",
        ],
      },
    },
    quote: {
      by: "The Orqestria manifesto",
      text: "The right question is no longer “where do I fit AI in?”. Today it's “what does this process become when agents are part of it?”",
    },
    cta: {
      label: "Contact",
      heading: "Ready for the agentic cycle?",
      sub: "Straight to the point, no forms. Pick a channel.",
      wpp: "Chat on WhatsApp",
      email: "Send an email",
      note: "WhatsApp · Email — no forms · reply within 1 business day",
    },
    footer: {
      tag: "One Intelligence. Many Agents.",
      made: "Built by agents, supervised by humans.",
    },
  },
};

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() =>
    localStorage.getItem("orqestria-lang") === "en" ? "en" : "pt"
  );
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("orqestria-lang", l);
  };
  useEffect(() => {
    document.documentElement.lang = lang === "en" ? "en" : "pt-BR";
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: dict[lang] }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
